import { RESET_STATE, SET_THERMOBOXES, SET_IS_THERMOBOXES_LOADING, SET_PAGINATION } from './actions';

export const initialState = {
	thermoboxes: [],
	isThermoboxesLoading: false,
	pagination: null,
};

const thermoboxesContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_THERMOBOXES:
			return {
				...state,
				thermoboxes: payload,
			};
		case SET_IS_THERMOBOXES_LOADING:
			return {
				...state,
				isThermoboxesLoading: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default thermoboxesContainerReducer;
